import React from "react";

import Col from "antd/es/col";
import Row from "antd/es/row";

import IntegrationService from "@mapmycustomers/shared/enum/integrations/IntegrationService";

import SUPPORTED_SERVICES from "@app/store/integrations/supported-services";

import ServiceButton from "../ServiceButton";

interface Props {
  onChange?: (service: IntegrationService | undefined) => void;
  selectedService?: IntegrationService;
}

const ServiceButtons: React.FC<Props> = ({ onChange, selectedService }) => (
  <Row gutter={16} justify="space-between">
    {SUPPORTED_SERVICES.map((serviceDescription) => (
      <Col key={serviceDescription.type} sm={{ span: 12 }} xl={{ span: 6 }}>
        <ServiceButton
          {...serviceDescription}
          onSelect={onChange}
          selectedService={selectedService}
        />
      </Col>
    ))}
  </Row>
);

export default ServiceButtons;
